<template>
  <div class="consulting">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">IT Consulting</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <!-- PC -->
          <v-tabs class="d-none d-sm-block" grow v-model="tabs">
            <v-tab>IT 기획&amp;컨설팅</v-tab>
            <v-tab>Enterprise Portal 기획/컨설팅</v-tab>
            <v-tab>Mobile 기획/컨설팅</v-tab>
            <v-tab>업무자동화(RPA) 컨설팅</v-tab>
          </v-tabs>
          
          <!-- mobile -->
          <v-tabs class="d-sm-none mob" grow vertical v-model="tabs">
            <v-tab>IT 기획&amp;컨설팅</v-tab>
            <v-tab>Enterprise Portal 기획/컨설팅</v-tab>
            <v-tab>Mobile 기획/컨설팅</v-tab>
            <v-tab>업무자동화(RPA) 컨설팅</v-tab>
          </v-tabs>

          <!-- image cashing loading -->
          <img src="@/assets/img_sub_ser_consulting01.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_consulting02.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_consulting03.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_consulting04.svg" style="display:none; " />

          <v-tabs-items v-model="tabs" class="mt-10">
            <v-tab-item>
              <v-sheet width="100%" class="d-flex" style="background:transparent">
                <img src="@/assets/img_sub_ser_consulting01.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">IT 기획/컨설팅</dt>
                <dd class="px-4">고객의 IT 추진계획에 대한 의사결정 및 전략 수립 지원 및<br>효과적인 IT 아웃소싱 관리체계 수립.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item>
              <v-sheet width="100%" class="d-flex" style="background:transparent">
                <img src="@/assets/img_sub_ser_consulting02.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">Enterprise Portal 기획/컨설팅</dt>
                <dd class="px-4">제품(SAP/TIBCO/Oracle/Acube) 기반.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item>
              <v-sheet width="100%" class="d-flex" style="background:transparent">
                <img src="@/assets/img_sub_ser_consulting03.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">Mobile 기획/컨설팅</dt>
                <dd class="px-4">App (IOS/Android) 및 Legacy Service.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item>
              <v-sheet width="100%" class="d-flex" style="background:transparent">
                <img src="@/assets/img_sub_ser_consulting04.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">업무자동화(RPA) 컨설팅</dt>
                <dd class="px-4">검증된 RPA 솔루션 도입과 RPA 표준 구축환경을 구성하고, 설계/개발/배포/운영 및 성과평가 기준을 수립.</dd>
              </dl>
            </v-tab-item>
          </v-tabs-items>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'consulting',
  data() {
    return {
      tabs: null,
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".consulting .sub-body-title", {
      scrollTrigger: {
        trigger: ".consulting .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".consulting .sub-body-content", {
      scrollTrigger: {
        trigger: ".consulting .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>